import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { getUserApi, logout } from '../api/api';
import { updateTokens } from '../api/utils';
import { useUserStore } from '../stores';
import { useNavigate } from 'react-router-dom';

const useHandleRedirectAuth = () => {
  const [searchParams] = useSearchParams();
  const accessToken = searchParams.get('access_token');
  const refreshToken = searchParams.get('refresh_token');
  const { setUser, setAuthorized } = useUserStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (accessToken && refreshToken) {
      const fetch = async () => {
        await logout();
        await updateTokens(accessToken, refreshToken, false);
        setAuthorized(false);
        setUser(null);
        await getUserApi(
          function (data) {
            setUser(data);
            setAuthorized(true);
            navigate('/user');
          },
          function (err) {
            setAuthorized(false);
          },
          false
        );
      };
      fetch();
    }
  }, []);
};

export default useHandleRedirectAuth;
